module.exports = __webpack_public_path__ + "a8da06125138e54d2ccc9ddef69c0762.png";